export default function(fields, activity = {}) {
  return {
    ...activity,
    ...fields,
    helpers: undefined,
  }
}
